import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import EirModal from '../eir-modal/EirModal';

function getSteps() {
    return ['Broadband', 'TV', 'Mobile', 'Checkout'];
}

function EirCustomisePageCartDock(props) {
    const { setCustmiseCheckoutActiveStep } = props;
    const activeStep = props.custmiseCheckoutActiveStep;
    const [modal, setModal] = useState(false);
    const steps = getSteps();
    const isNGB = (localStorage.getItem("eir_be_data")) ? (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type) : "";
    const isNBI = (localStorage.getItem("eir_be_data")) ? (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.inbi == true) : "";
    const [newCust, setnewCust] = useState(true);

    //**** click of next button cart doc ****/
    const handleNext = (event) => {
        document.querySelector(".step_next").click();
        
        //to scroll top of the screen, when next button is clicked
        window.scroll(0,0); 
    };

    //**** click of checkout button ****/
    const handleCheckout = () => {
        if (($('input[name=mobilePlans]:checked').val()) != "withPhone") {
            window.location.href = "/checkout/order-summary";
        }
        else if ((activeStep == 2) && ((JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder.length < 1) || ($('input[name=portingOptions]:checked').length < 1))) {
            setModal(true);
        }
        else {
            window.location.href = "/checkout/order-summary";
        }
    };

    //**** for Modal *****/
    const handleToggle = () => {
        setModal(!modal);
    }
    const gotoCheckout = () => {
        setModal(!modal);
        window.location.href = "/checkout/order-summary";
    }
    const handlePickPlan = () => {
        setModal(!modal);
    }
    /**** *******/
    useEffect(() => {
        const custType = localStorage.getItem("global_customer_type");

        //** check customer type and hide setup fees*/
        if (custType == "new") {
            setnewCust(true);
        }
        else {
            setnewCust(false);
        }

    }, [setCustmiseCheckoutActiveStep]);

    const OverlayHeading = "Wait!";
    const OverlayCopy1 = " You've choosen a phone - do you want to pick a plan or continue without a phone? ";
    const OverlayCopy2 = "";

    return (
        <div className={((activeStep === 3) ? "d-none" : "customise-cart-dock")}>
            <div className="cart-doc-ctr container">
                <div className={((activeStep >= 2) ? "cart-doc-price-details-after col-12" : "cart-doc-price-details col-12") + ((isNGB === "NGB" && activeStep >= 1) ? " cart-doc-price-details-after col-12" : "cart-doc-price-details col-12")+ ((isNBI) ? " cart-doc-price-details-after col-12" : " cart-doc-price-details col-12")}>

                    <div className="application-page__sidebar__pay-monthly__discounts__total__heading__container text-right col-4">
                        <h4 className="application-page__sidebar__pay-monthly__discounts__total__heading mr-0">
                            Monthly Bill
                        </h4>
                        <p className="application-page__sidebar__pay-monthly__total__price w-100">
                        </p>
                    </div>
                    {newCust && <div className="application-page__sidebar__pay-monthly__discounts__total__heading__container text-right col-4">
                        <h4 className="application-page__sidebar__pay-monthly__discounts__total__heading mr-0">
                            Setup Fees
                        </h4>
                        <p className="cartdoc-setup-fees w-100"> </p>
                    </div>}
                    {/* --------------phone price start */}
                    < div className="d-none application-page__sidebar__pay-monthly__discounts__total__heading__container application-page__sidebar__your-mobile-details__total__price__container text-right col-4">
                        <h4 className="application-page__sidebar__pay-monthly__discounts__total__heading mr-0 ">
                            Phone Cost
                        </h4>
                        <div class="application-page__sidebar__your-mobile-details__bundle__item__container" data-state="visible">
                            <div class="application-page__sidebar__your-mobile-details__bundle__item">
                                <div class="application-page__sidebar__your-mobile-details__bundle__item__image__container_extra-padding">
                                    <div class="application-page__sidebar__your-mobile-details__bundle__item__mobile-image__close js-tooltip-application-page__sidebar__your-mobile-details__bundle__item__close remove-mobile tooltipstered" data-mobile-id="63c1180e-7099-480b-9ebc-63d3bdaeeb1b" data-tooltip="true" data-tooltip-type="interactive" data-tooltip-title="Do you want to remove Samsung Galaxy Note 20 Ultra  and plan?" data-tooltip-body="By removing this product from your shopping cart your new bundle total will be €39.99." data-tooltip-button-one-text="Yes, Remove" data-tooltip-button-one-event="ap-config-remove-mobile" data-tooltip-button-two-text="No, Don't Remove" data-tooltip-button-two-event="close-tooltip">
                                    </div>
                                </div>
                                <div class="application-page__sidebar__your-mobile-details__bundle__item__text__container">
                                    <div class="application-page__sidebar__your-mobile-details__bundle__item__text">eir mobile connect plus with Samsung Galaxy Note 20 Ultra  (black)
                                    </div>
                                </div>
                                <div class="application-page__sidebar__your-mobile-details__total__price__container">
                                    <p class="application-page__sidebar__your-mobile-details__total__price">€749.00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* --------------phone price end */}

                </div>
                <div class="cart-doc-buttons" >
                    <Button className={((activeStep >= 2) ? "d-none" : " next-cta") + ((isNGB === "NGB" && activeStep >= 1) ? " d-none" : " next-cta") +((isNBI && activeStep == 0) ? " d-none":" next-cta")} onClick={handleNext} >
                        Next
                    </Button>
                    <Button className={((activeStep >= 2) ? "coloured_checkout-cta" : "checkout-cta") + ((isNGB === "NGB" && activeStep >= 1) ? " coloured_checkout-cta" : " checkout-cta")+((isNBI && activeStep == 0) ? " coloured_checkout-cta" : " checkout-cta")} onClick={handleCheckout}>
                        Checkout
                    </Button>
                </div>
            </div>
            {/* </div> */}
            {/* <div className="application-page__sidebar__pay-monthly__discounts__info__container">
                        <div className="application-page__sidebar__pay-monthly__discounts__info">
                            <div className="application-page__sidebar__pay-monthly__discounts__info__text__container">
                                <p className="application-page__sidebar__pay-monthly__discounts__info__text">

                                </p>
                            </div>
                        </div>
                    </div> */}
            {/* <div className="application-page__sidebar__additional-info">
                    </div> */}
            {/* <div className="application-page__sidebar__pay-monthly__payment__breakdown__container">
                        <div className="application-page__sidebar__pay-monthly__discounts__show-details__info js-pay-monthly-show-details-info"
                            style={{ display: "none" }}>
                            <h4 className="application-page__sidebar__pay-monthly__discounts__show-details__info__heading">Your
                    Monthly Payment Breakdown</h4>
                            <p className="application-page__sidebar__pay-monthly__discounts__show-details__info__text"></p>
                        </div>
                        <a className="application-page__sidebar__pay-monthly__discounts__show-details__button js-pay-monthly-show-details gtm-normal-cta"
                            data-tooltip="true" data-tooltip-type="interactive" data-tooltip-position="top" data-tooltip-body=''
                            data-tooltip-button-one-text="Close Window" data-tooltip-button-one-event="close-tooltip">
                            Payment Breakdown
            </a>
                    </div> */}
            {/* </div>
            </div> */}
            <EirModal
                className="customise-billPay-modal-outer"
                centered={true}
                Modal={modal}
                handleToggle={handleToggle}
                img={"/opencms/export/sites/default/.galleries/customise-page/icon-close.png"}
                OverlayHeading={OverlayHeading}
                OverlayCopy1={OverlayCopy1}
                OverlayCopy2={OverlayCopy2}
                cta1={true}
                cta1outline={true}
                cta1type="button"
                cta1text="I don't want a phone"
                cta1title="I don't want a phone"
                cta1onClick={gotoCheckout}
                cta2={true}
                cta2outline={true}
                cta2type="button"
                cta2text="Pick a plan"
                cta2title="Pick a plan"
                cta2onClick={handlePickPlan}
            ></EirModal>
        </div >

    );
}
export default EirCustomisePageCartDock;
